import React, { Component } from "react";
import { Grid, Row, Col, Panel } from "react-bootstrap";
import Radium from "radium";
import {
  styles,
  PageTitle,
  Filters,
  Header,
  Minus,
  Plus,
  SubMenu,
} from "./style.ts";
import filterImg from "../../../images/filter.png";
import Utils from "../../../lib/utils";

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [
        { id: 0, expanded: false },
        { id: 1, expanded: false },
        { id: 2, expanded: false },
        { id: 3, expanded: false },
      ],
      filters: {
        city_in: [],
        country_in: [],
        employment_type_in: [],
        state_in: [],
        title: [],
      },
    };
  }

  componentWillMount() {
    this.initFilters();
  }

  componentWillReceiveProps() {
    this.initFilters();
  }

  formatHeader = (str) => str.toLowerCase().replace(" ", "-");

  initFilters = () => {
    const { filters } = this.props;
    const checkboxes = Array.from(document.getElementsByTagName("Input"));
    checkboxes.forEach((cb) => {
      Object.keys(filters).forEach((attrs) => {
        if (filters[attrs][0] === cb.value) cb.checked = true;
      });
    });
  };

  filterResults = (e) => {
    const { filters } = this.state;
    const { search } = this.props;
    let currentFilters = filters[e.target.name] || [];
    if (e.target.checked) {
      currentFilters = currentFilters.concat(e.target.value);
    } else {
      currentFilters = currentFilters.filter(
        (filter) => filter !== e.target.value
      );
    }

    this.setState(
      {
        filters: {
          ...filters,
          [e.target.name]: currentFilters,
        },
      },
      () => this.persistFilters(filters)
    );
    search({ ...filters, [e.target.name]: currentFilters });
  };

  filters = () => {
    const { filters } = this.props;
    const formatFilters = [
      {
        header: "Title",
        values:
          filters && filters.titles && filters ? filters.titles.values : [],
        link: "/jobs/#",
      },
      {
        header: "City",
        values:
          filters && filters.titles && filters ? filters.cities.values : [],
        link: "/jobs/#",
      },
      {
        header: "State",
        values:
          filters && filters.titles && filters ? filters.states.values : [],
        link: "/jobs/#",
      },
      {
        header: "Country",
        values:
          filters && filters.titles && filters ? filters.countries.values : [],
        link: "/jobs/#",
      },
      {
        header: "Employment Type",
        values:
          filters && filters.titles && filters
            ? filters.employmentTypes.values
            : [],
        link: "/jobs/#",
      },
    ];
    return formatFilters.filter((e) => e.values.length > 0);
  };

  toggle = (_, e) => {
    const { selected } = this.state;
    const newItem = {
      id: e,
      expanded: selected[e] ? selected[e].expanded : true,
    };

    selected.filter((item) => item.id !== e);

    this.setState({
      selected: selected
        .filter((item) => item.id !== e)
        .concat(newItem)
        .sort((a, b) => a.id - b.id),
    });
  };

  persistFilters() {
    const { filters } = this.state;
    const persistedFilters = Utils.clean(filters);
    localStorage.setItem("jobFilters", JSON.stringify(persistedFilters));
  }

  render() {
    const { selected } = this.state;
    return (
      <Grid
        style={styles.container}
        className="hidden-xs"
        id="jobs-filter"
        fluid
      >
        <Row>
          <Col>
            <PageTitle>
              <img src={filterImg} alt="Filter Results" />
              <span className="title">Filter Results</span>
            </PageTitle>
            <Filters>
              {this.filters().map((filter, i) => {
                const header = filter.header.toLowerCase();
                return (
                  <Panel
                    onSelect={(_) => this.toggle(_, i)}
                    collapsible
                    header={
                      <Header>
                        {filter.header}
                        <i className="pull-right" aria-hidden="true">
                          {selected.find((item) => item.id === i).expanded ? (
                            <Minus />
                          ) : (
                            <Plus />
                          )}
                        </i>
                      </Header>
                    }
                    key={i}
                    eventKey={i}
                  >
                    <SubMenu>
                      {filter.values.map((v, j) => (
                        <li key={j}>
                          <span className="row">
                            <input
                              className="css-checkbox"
                              id={`${v} - ${j}`}
                              name={`${header}_in`}
                              type="checkbox"
                              value={v}
                              onClick={this.filterResults}
                            />
                            <label
                              className="css-label"
                              htmlFor={`${v} - ${j}`}
                              style={{ color: "#999" }}
                            >
                              {v}
                            </label>
                          </span>
                        </li>
                      ))}
                    </SubMenu>
                  </Panel>
                );
              })}
            </Filters>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Radium(Filter);
